import { faPlus } from '@fortawesome/free-solid-svg-icons';
import MyButton from 'components/form/MyButton';
import TopBar from 'components/layout/TopBar';
import { callAxios } from 'components/utils/FormatData';
import { genKey, setStorage } from 'components/utils/Storage';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ClipLoader } from 'react-spinners';
import ActionsUsersRenderer from '../../components/agGrid/ActionsUsersRenderer';
import AgGrid from '../../components/agGrid/AgGrid';
import PhoneRenderer from '../../components/agGrid/PhoneRenderer';
import TypeProfilRenderer from '../../components/agGrid/TypeProfilRenderer';
import MyInput from '../../components/form/MyInput';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';


const Users = (props) => {
  const history = useHistory();
  const alert = useAlert();
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(false);
  const [componentHeight, setComponentHeight] = useState(height - 130);
  const [users, setUsers] = useState([]);
  const [needUpdate, setNeedUpdate] = useState(false);
  const [filters, setFilters] = useState({ search: '' });
  const [columnDefs] = useState([
    { headerName: 'login', field: 'login', suppressMovable: true, flex: 1, minWidth: 150, sortable: true, sort: 'asc' },
    { headerName: 'nom', field: 'nom', suppressMovable: true, flex: 1, minWidth: 150, sortable: true },
    { headerName: 'prenom', field: 'prenom', suppressMovable: true, flex: 1, minWidth: 150, sortable: true },
    { headerName: 'email', field: 'email', suppressMovable: true, flex: 2, minWidth: 250, sortable: true },
    { headerName: 'role', field: 'role', suppressMovable: true, flex: 1, minWidth: 150, sortable: true, cellRenderer: 'typeProfilRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: true } },
    { headerName: 'tel. fixe', field: 'telephoneFixe', suppressMovable: true, flex: 1, minWidth: 125, sortable: true, cellRenderer: 'phoneRenderer', },
    { headerName: 'tel. mobile', field: 'telephoneMobile', suppressMovable: true, flex: 1, minWidth: 125, sortable: true, cellRenderer: 'phoneRenderer', },
    { headerName: 'Gmao', field: 'gmaoEmployee', suppressMovable: true, flex: 1, minWidth: 100, sortable: true },
    { headerName: '', field: '', suppressMovable: true, flex: 1, minWidth: 75, sortable: false, cellRenderer: 'actionsUsersRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: true }, },
  ]);
  const [columnDefsDegraded] = useState([
    { headerName: 'login', field: 'login', suppressMovable: true, flex: 1, minWidth: 150, sortable: true, sort: 'asc' },
    { headerName: 'nom', field: 'nom', suppressMovable: true, flex: 1, minWidth: 150, sortable: true },
    { headerName: 'prenom', field: 'prenom', suppressMovable: true, flex: 1, minWidth: 150, sortable: true },
    { headerName: 'email', field: 'email', suppressMovable: true, flex: 1, minWidth: 250, sortable: true },
    { headerName: 'role', field: 'role', suppressMovable: true, flex: 1, minWidth: 150, sortable: true, cellRenderer: 'typeProfilRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: false } },
    { headerName: 'tel. fixe', field: 'telephoneFixe', suppressMovable: true, flex: 1, minWidth: 125, sortable: true, cellRenderer: 'phoneRenderer' },
    { headerName: 'tel. mobile', field: 'telephoneMobile', suppressMovable: true, flex: 1, minWidth: 125, sortable: true, cellRenderer: 'phoneRenderer', },
    { headerName: 'Gmao', field: 'gmaoEmployee', suppressMovable: true, flex: 1, minWidth: 100, sortable: true },
    { headerName: '', field: '', suppressMovable: true, flex: 1, minWidth: 75, sortable: false, cellRenderer: 'actionsUsersRenderer', cellRendererParams: { setNeedUpdate: setNeedUpdate, wsStatus: false } },
  ]);
  const [contratGridOptions, setContratGridOptions] = useState({
    suppressCellSelection: true,
    suppressHorizontalScroll: false,
    animateRows: true,
  });
  const frameworkComponents = {
    typeProfilRenderer: TypeProfilRenderer,
    phoneRenderer: PhoneRenderer,
    actionsUsersRenderer: ActionsUsersRenderer,
  };
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    document.title = 'SED - Utilisateurs';
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error(`Vous n'êtes pas autorisé à accéder à cet écran`);
      history.push('/');
    }
  }, []);
  useEffect(() => {
    setComponentHeight(height - (90 + document.getElementById('component-topbar').clientHeight));
  }, [width, height]);
  useEffect(() => {
    if (needUpdate) {
      fetchLoadUsers();
      setNeedUpdate(false);
    }
  }, [needUpdate]);
  useEffect(() => {
    if (props.wsStatus !== null) {
      fetchLoadUsers();
    }
  }, [props.wsStatus]);

  // Récupération de la liste des utilisateurs
  const fetchLoadUsers = () => {

    callAxios(props.wsStatus, "param_users", { method: 'get', url: URL_API + '/utilisateurs' }, setLoading, alert)
      .then((res) => {
        setUsers(res);
        setStorage(genKey("param_users"), res);
      });

  };

  // Modification du filtre
  const changeSearchData = (e) => {
    setFilters({ ...filters, 'search': e.target.value });
  };

  // Ouverture de l'écran de création d'un nouvel utilisateur
  const handleOpenNewUser = () => {
    history.push('/utilisateurs/creation');
  };

  if (isMobile) {
    return (
      <div id="users" className='panel-contenu-mobile-tablette' style={{ height: height - 60 }}>
        <TopBar title="utilisateurs" className={'topbar-contenu-mobile-tablette'} color={props.params.color}
          buttons={
            <div className="boutons-topbar-contenu">
              {
                props.wsStatus &&
                <MyButton className="classic-button btn-default color-fond-bleu" type="button" labelImportant="Nouvel utilisateur" href="#"
                  iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                  onClick={() => handleOpenNewUser()}
                />
              }
              {
                !props.wsStatus &&
                <MyButton className="classic-button btn-default color-fond-gris" type="button" labelImportant="Nouvel utilisateur" href="#"
                  iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                  styleCss={{ cursor: 'default' }}
                />
              }
              <MyInput
                handleChange={changeSearchData}
                value={filters.search}
                label="Recherche"
                size="small"
              />
            </div>
          } />
        <div className="composant-content-center" style={{ height: componentHeight }}>

          <ClipLoader
            color="#0094ca"
            loading={loading}
            css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
            size={50}
          />

          {!loading &&
            <AgGrid
              key={"ag-grid-ws-" + props.wsStatus}
              rowData={users}
              columnDefs={props.wsStatus ? columnDefs : columnDefsDegraded}
              height={componentHeight}
              rowHeight={50}
              pagination={false}
              frameworkComponents={frameworkComponents}
              gridOptions={contratGridOptions}
              setGridOptions={setContratGridOptions}
              sortable={false}
              filters={filters}
              agGridName="ag-grid-overflow"
            />
          }

        </div>
      </div>
    );

  }

  return (
    <div id="users" className='panel-contenu' style={{ height: height - 90 }}>
      <TopBar title="utilisateurs" className='topbar-contenu' color={props.params.color}
        buttons={
          <div className="boutons-topbar-contenu">
            {
              props.wsStatus &&
              <MyButton className="classic-button btn-default color-fond-bleu" type="button" labelImportant="Nouvel utilisateur" href="#"
                iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                onClick={() => handleOpenNewUser()}
              />
            }
            {
              !props.wsStatus &&
              <MyButton className="classic-button btn-default color-fond-gris" type="button" labelImportant="Nouvel utilisateur" href="#"
                iconLeft={{ icon: faPlus, type: 'fontAwesome' }}
                styleCss={{ cursor: 'default' }}
              />
            }
            <MyInput
              handleChange={changeSearchData}
              value={filters.search}
              label="Recherche..."
              size="small"
            />
          </div>
        } />
      <div className="composant-content-center" style={{ height: componentHeight }}>

        <ClipLoader
          color="#0094ca"
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
          size={50}
        />

        {!loading &&
          <AgGrid
            key={"ag-grid-ws-" + props.wsStatus}
            rowData={users}
            columnDefs={props.wsStatus ? columnDefs : columnDefsDegraded}
            height={componentHeight}
            rowHeight={50}
            pagination={false}
            frameworkComponents={frameworkComponents}
            gridOptions={contratGridOptions}
            setGridOptions={setContratGridOptions}
            sortable={false}
            filters={filters}
            agGridName="ag-grid-overflow"
          />
        }

      </div>
    </div>
  );

};

export default Users;